import React, { useMemo } from 'react';
// import { useController } from "react-hook-form";;
import { useForm } from 'react-hook-form';
import { valueIsRequired } from '../../utils/regex';
import Input from '../InputControlled';
import { FormInputRadio } from '../StyledComponents';
import Grid from '@material-ui/core/Grid';

const Action = ({
  checked,
  nameAction,
  descAction,
  value: valueProps,
  onChange,
  onCheck,
  id,
  disabled = false
}) => {
  const { control: actionControl } = useForm({
    defaultValues: useMemo(() => {
      return valueProps;
    }, [valueProps]),
  });
  return (
    <Grid
      container
      direction="row"
      justifyContent="space-between"
      alignItems="center"
    >
      <Grid item md={5}>
        <Input
          name={nameAction}
          control={actionControl}
          rules={{ ...valueIsRequired() }}
          onChangeDefault={(v) => {
            onChange(valueProps[id], nameAction, v);
          }}
          disabled={true}
          background="#f1f1f1"
          cursor={'no-drop'}
        />
      </Grid>
      <Grid item alignItems="center">
        <div
          style={{ marginBottom: '1rem', marginLeft: '0.5rem' }}
          onClick={() => {
            onCheck(valueProps);
          }}
        >
          <FormInputRadio type="radio" checked={checked} />
        </div>
      </Grid>
      <Grid item md={6}>
        <div style={{ marginTop: '1rem' }}>
          <Input
            disabled={disabled}
            name={descAction}
            control={actionControl}
            rules={{ ...valueIsRequired() }}
            onChangeDefault={(v) => {
              onChange(valueProps[id], descAction, v);
            }}
            maxLength={140}
          />
        </div>
      </Grid>
    </Grid>
  );
};

export default Action;
